import React from 'react';
import { useUIStore } from '../../store/uiStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const ToastContainer = () => {
  const { toasts, removeToast } = useUIStore();

  const getIcon = (type) => {
    switch (type) {
      case 'success': return faCheckCircle;
      case 'warning': return faExclamationTriangle;
      case 'error': return faExclamationTriangle;
      default: return faInfoCircle;
    }
  };

  const getClass = (type) => {
    switch (type) {
      case 'success': return 'bg-green-600 text-white';
      case 'warning': return 'bg-yellow-600 text-white';
      case 'error': return 'bg-red-600 text-white';
      default: return 'bg-blue-600 text-white';
    }
  };

  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="fixed sm:top-4 sm:right-4 top-0 left-0 right-0 z-[100] p-4 sm:p-0 sm:space-y-2 flex flex-col items-center sm:items-end pointer-events-none" aria-live="polite">
      {toasts.map((t) => {
        const isAssertive = t.type === 'error' || t.type === 'warning';
        const role = isAssertive ? 'alert' : 'status';
        const ariaLive = isAssertive ? 'assertive' : 'polite';
        return (
          <div
            key={t.id}
            role={role}
            aria-live={ariaLive}
            aria-atomic="true"
            aria-label={t.ariaLabel || `${t.type || 'info'} notification`}
            className={`shadow-2xl rounded-xl px-4 py-3 flex items-center ${getClass(t.type)} transition-all duration-300 pointer-events-auto mb-2 w-full max-w-sm border border-white/10 animate-in fade-in slide-in-from-top-2`}
          >
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/20 flex items-center justify-center mr-3">
              <FontAwesomeIcon icon={getIcon(t.type)} className="text-sm" />
            </div>
            <span className="text-sm font-bold flex-1 leading-tight">{t.message}</span>
            {t.actionLabel && typeof t.onAction === 'function' && (
              <button
                className="ml-3 px-3 py-1.5 bg-white text-gray-900 hover:bg-gray-100 rounded-lg text-[10px] font-black uppercase tracking-wider transition-colors shadow-sm"
                onClick={() => { try { t.onAction(); } finally { removeToast(t.id); } }}
              >
                {t.actionLabel}
              </button>
            )}
            {t.closable !== false && (
              <button
                className="ml-3 w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/20 text-white/80 hover:text-white transition-colors"
                title="Dismiss"
                aria-label="Dismiss notification"
                onClick={() => removeToast(t.id)}
              >
                <span className="text-xl leading-none">&times;</span>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ToastContainer;
